import { Component } from "react";
import AttributesIcon from "../resources/images/icons-attribute.svg";
import { Placeholder } from "./Placeholder";

export class TablePlaceholder extends Component<any, any> {
  static defaultProps = {
    icon: <AttributesIcon />
  };

  render() {
    return (
      <Placeholder
        className='klayo-tableplaceholder'
        sx={{ top: { xs: "0", md: "-56px" } }}
        {...this.props}
      />
    );
  }
}
